export const TRANSLATIONS_DA = {
  "routes_Pages": "Sider",
  "routes_Dashboard": "Dashboard",
  "routes_Questionnaire": "Standarder",
  "routes_Stats": "Statistik",
  "routes_Settings": "Indstillinger",
  "routes_Resouces": "Ressourcer",
  "routes_Contact": "Kontakt",
  "routes_Downloads": "Downloads",
  "routes_Documentation": "Dokumentation",
  "dashboard_welcome_message": "Velkommen til Accessibility Management System Dashboard 👋",
  "dashboard_label": "Alle dine tilgængelighedsdata er samlet, struktureret og overvåget ét sted.",
  "gettingStartedCard_gettingStarted": "Kom godt i gang",
  "gettingStartedCard_gettinStartedDescription": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam elementum dui nunc, ac porta sem consequat nec. Pellentesk",
  "gettingStartedCard_Steps": "Vi anbefaler disse trin til at starte med:",
  "gettingStartedCard_step1": "Læs dokumentationen",
  "gettingStartedCard_step2": "Hent Tjeklisten",
  "gettingStartedCard_step3": "Tjek din statistik",
  "companyCard_supportedStandards": "Understøttede standarder:",
  "companyCard_companyInformation": "Virksomhedsoplysninger",
  "companyCard_numberOfEmployees": "medarbejdere",
  "propertyListPage_propertyList": "Ejendomsliste",
  "propertyListPage_dashboard": "Dashboard",
  "propertyListPage_Questionnaire": "Standarder",
  "propertyListPage_newProperty": "Ny ejendom",
  "propertyListPage_textmapEdit": "Rediger egenskab",
  "propertyListPage_textmapQuestionnaire": "Klassificer",
  "propertyListPage_textmapFacility": "Rediger facilitet",
  "propertyListPage_textmapNewProperty": "Ny ejendom",
  "propertyListPage_createNewProperty": "Opret ny ejendom",
  "propertyListPage_disabilityClassification": "Klassificering af handicap",
  "propertyListPage_editProperty": "Rediger egenskab",
  "propertyListPage_editFacilities": "Rediger faciliteter",
  "propertyListPage_classify": "Klassificer",
  "propertyListPage_search": "Søg efter ejendomsnavn",
  "propertyForm_propertyInformation": "1.1 Ejendomsoplysninger",
  "propertyForm_standardType": "Standard Type",
  "propertyForm_fieldCannotBeChanged": "Dette felt kan ikke ændres",
  "propertyForm_propertyCategory": "Ejendomskategori",
  "propertyForm_typeOfProperty": "Type ejendom",
  "propertyForm_propertyName": "Ejendomsnavn",
  "propertyForm_propertyArea": "Mængde kvadratmeter gulvoverflade",
  "propertyForm_enterPropertyAddress": "1.1.2 Indtast ejendomsadresse",
  "propertyForm_addressLocation": "Indtast adressen nedenfor",
  "propertyForm_mapNote": "Hvis det er nødvendigt, kan du justere kortet, så nålen er på den rigtige placering",
  "propertyForm_keyPropertyData": "1.2 Vigtige ejendomsdata",
  "propertyForm_floorsQuestion": "Hvor mange etager har din ejendom?",
  "propertyForm_roomsQuestion": "Hvor mange værelser har din ejendom?",
  "propertyForm_disabledRoomsQuestion": "Hvor mange handicapværelser har din ejendom?",
  "propertyForm_alergyRoomsQuestion": "Hvor mange allergirum har din ejendom?",
  "propertyForm_save": "Gemme",
  "propertyForm_propertyHotelTypeOptionsLabel_Hotel": "Hotel",
  "propertyForm_propertyHotelTypeOptionsLabel_Motel": "Motel",
  "propertyForm_propertyConvenienceStoreOptions_Candies": "Slik",
  "propertyForm_propertyConvenienceStoreOptions_Newspapers": "Aviser",
  "propertyForm_propertyConvenienceStoreOptions_TobaccoProducts": "Tabaksprodukter",
  "propertyForm_propertyConvenienceStoreOptions_Toiletries": "Toiletartikler",
  "propertyForm_propertyConvenienceStoreOptions_Store": "butik",
  "propertyForm_propertyConvenienceStoreOptions_Supermarket": "Supermarked",
  "propertyForm_propertyDepartmentStoreOptions_Clothing": "Tøj",
  "propertyForm_propertyDepartmentStoreOptions_DepartmentStore": "Stormagasin",
  "propertyForm_propertyDepartmentStoreOptions_Electronics": "Elektronik",
  "propertyForm_propertyDepartmentStoreOptions_Garden": "Have",
  "propertyForm_propertyDepartmentStoreOptions_Household_goods": "Husholdningsartikler",
  "propertyForm_propertyDepartmentStoreOptions_Pets": "Kæledyr",
  "propertyForm_propertyDepartmentStoreOptions_Toys": "Legetøj",
  "propertyForm_propertyFoodAndDrinkOptions_bakery_and_baked_goods_store": "Bageri og bagværk",
  "propertyForm_propertyFoodAndDrinkOptions_dairy_goods": "Mejerivarer",
  "propertyForm_propertyFoodAndDrinkOptions_food_and_drink": "Mad og drikke",
  "propertyForm_propertyFoodAndDrinkOptions_food_beverage_specialty_store": "Mad og drikke specialbutik",
  "propertyForm_propertyFoodAndDrinkOptions_grocery": "Købmand",
  "propertyForm_propertyFoodAndDrinkOptions_meat": "Kød",
  "propertyForm_propertyFoodAndDrinkOptions_specialty_food_store": "Specialfødevarebutik",
  "propertyForm_propertyFoodAndDrinkOptions_Vegan": "Vegansk",
  "propertyForm_propertyFoodAndDrinkOptions_Vegetarian": "Vegetarisk",
  "propertyForm_propertyFoodAndDrinkOptions_wine_and_liquor": "Vin og spiritus",
  "propertyForm_propertyDrugstoreOptions_drugstore": "Apotek",
  "propertyForm_propertyDrugstoreOptions_pharmacy": "Apotek",
  "propertyForm_propertyElectronicsOptions_computer_and_software": "Computer og software",
  "propertyForm_propertyElectronicsOptions_consumer_electronics_store": "Forbrugerelektronikbutik",
  "propertyForm_propertyElectronicsOptions_electronics": "Elektronik",
  "propertyForm_propertyElectronicsOptions_entertainment_electronics": "Underholdning_elektronik",
  "propertyForm_propertyElectronicsOptions_mobile_retailer": "Mobil forhandler",
  "propertyForm_propertyElectronicsOptions_mobile_service_center": "Mobilt servicecenter",
  "propertyForm_propertyMallOptions_shopping_gallery_mall": "Indkøbsgalleri",
  "propertyForm_propertyMallOptions_shopping_mall": "Indkøbscenter",
  "propertyForm_standardTypeOptions_hotel_motel": "Hotel/Motel",
  "propertyForm_standardTypeOptions_shopping_mall": "Indkøbscenter",
  "propertyForm_standardTypeOptions_shop": "Butik",
  "propertyForm_propertyHardwareOptions_floor_and_carpet": "Gulv og tæppe",
  "propertyForm_propertyHardwareOptions_furniture_store": "Møbelbutik",
  "propertyForm_propertyHardwareOptions_garden_center": "Havecenter",
  "propertyForm_propertyHardwareOptions_glass_and_window": "Glas og vindue",
  "propertyForm_propertyHardwareOptions_hardware_house_garden": "Hardware hushave",
  "propertyForm_propertyHardwareOptions_home_improvement_hardware_store": "Byggevareforretning til boligforbedring",
  "propertyForm_propertyHardwareOptions_home_specialty_store": "Specialbutik til hjemmet",
  "propertyForm_propertyHardwareOptions_lumber": "Tømmer",
  "propertyForm_propertyHardwareOptions_major_appliance": "Større apparat",
  "propertyForm_propertyHardwareOptions_paint_store": "Malerbutik",
  "propertyForm_propertyHardwareOptions_power_equipment_dealer": "Forhandler af eludstyr",
  "propertyForm_propertyBookstoreOptions_bookstore": "Boghandel",
  "propertyForm_propertyClothingOptions_childrens_apparel": "Børnetøj",
  "propertyForm_propertyClothingOptions_clothing_and_accessories": "Tøj og tilbehør",
  "propertyForm_propertyClothingOptions_mens_apparel": "Herre tøj",
  "propertyForm_propertyClothingOptions_shoes_footwear": "Sko fodtøj",
  "propertyForm_propertyClothingOptions_specialty_clothing_store": "Special tøjbutik",
  "propertyForm_propertyClothingOptions_womens_apparel": "Dametøj",
  "propertyForm_consumerGoodsOptions_adult_shop": "Voksen butik",
  "propertyForm_consumerGoodsOptions_arts_and_crafts_supplies": "Arts og kunsthåndværk forsyninger",
  "propertyForm_consumerGoodsOptions_bicycle_and_bicycle_accessories_shop": "Cykel- og cykeltilbehør butik",
  "propertyForm_consumerGoodsOptions_camping_hiking_shop": "Camping vandrebutik",
  "propertyForm_consumerGoodsOptions_canoe_kayak_shop": "Kano kajak butik",
  "propertyForm_consumerGoodsOptions_car_accessories": "Biltilbehør",
  "propertyForm_consumerGoodsOptions_consumer_goods": "Forbrugsvarer",
  "propertyForm_consumerGoodsOptions_cross_country_ski_shop": "Langrendsskibutik",
  "propertyForm_consumerGoodsOptions_florist": "Blomsterhandler",
  "propertyForm_consumerGoodsOptions_general_merchandise": "Generelle varer",
  "propertyForm_consumerGoodsOptions_gift_antique_art": "Gave antik kunst",
  "propertyForm_consumerGoodsOptions_hobby_store": "Hobby butik",
  "propertyForm_consumerGoodsOptions_hunting_fishing_shop": "Jagtfiskeri butik",
  "propertyForm_consumerGoodsOptions_jeweler": "Guldsmed",
  "propertyForm_consumerGoodsOptions_market": "Marked",
  "propertyForm_consumerGoodsOptions_motorcycle_accessories": "Motorcykel tilbehør",
  "propertyForm_consumerGoodsOptions_non_store_retailers": "Forhandlere uden for butikker",
  "propertyForm_consumerGoodsOptions_office_supply_store": "Kontorartikler butik",
  "propertyForm_consumerGoodsOptions_pawnshop": "Pantelånerbutik",
  "propertyForm_consumerGoodsOptions_pet_supply": "Udbud af kæledyr",
  "propertyForm_consumerGoodsOptions_record_cd_video": "Optag cd video",
  "propertyForm_consumerGoodsOptions_running_walking_shop": "Løbende gåbutik",
  "propertyForm_consumerGoodsOptions_skate_shop": "Skate butik",
  "propertyForm_consumerGoodsOptions_ski_snowboard_shop": "Ski snowboard butik",
  "propertyForm_consumerGoodsOptions_specialty_store": "Specialbutik",
  "propertyForm_consumerGoodsOptions_sporting_goods_store": "Sportsforretning",
  "propertyForm_consumerGoodsOptions_surf_shop": "Surf butik",
  "propertyForm_consumerGoodsOptions_tack_shop": "Tack butik",
  "propertyForm_consumerGoodsOptions_toy_store": "Legetøjsbutik",
  "propertyForm_consumerGoodsOptions_used_second_hand_merchandise_stores": "Brugte brugte varebutikker",
  "propertyForm_consumerGoodsOptions_variety_store": "Variety butik",
  "propertyForm_consumerGoodsOptions_video_and_game_rental": "Video- og spiludlejning",
  "propertyForm_consumerGoodsOptions_warehouse_wholesale_store": "Lager engros butik",
  "propertyForm_hairAndBeautyOptions_barber": "Barber",
  "propertyForm_hairAndBeautyOptions_hair_and_beauty": "Hår og skønhed",
  "propertyForm_hairAndBeautyOptions_hair_salon": "Frisørsalon",
  "propertyForm_hairAndBeautyOptions_nail_salon": "Negle salon",
  "propertyForm_hairAndBeautyOptions_make_up_salon": "Makeup salon",
  "propertyForm_mallTopCategoryOptions_mall_shopping_complex": "Indkøbscenter indkøbskompleks",
  "propertyForm_accomodationsCategoryOptions_hotel_motel": "Hotel/Motel",
  "propertyForm_shopCategoryOptions_convenience_store": "Dagligvarebutik",
  "propertyForm_shopCategoryOptions_department_store": "stormagasin",
  "propertyForm_shopCategoryOptions_food_and_drink": "Mad og drikke",
  "propertyForm_shopCategoryOptions_drugstore_or_pharmacy": "Apotek eller apotek",
  "propertyForm_shopCategoryOptions_electronics": "Elektronik",
  "propertyForm_shopCategoryOptions_hardware_house_garden": "Hardware hushave",
  "propertyForm_shopCategoryOptions_bookstore": "Boghandel",
  "propertyForm_shopCategoryOptions_clothing_and_accessories": "Tøj og tilbehør",
  "propertyForm_shopCategoryOptions_consumer_goods": "Forbrugsvarer",
  "propertyForm_shopCategoryOptions_hair_and_beauty": "Hår og skønhed",
  "facilitiesForm_standardTypeOptions_hotel_motel": "Hotel/Motel",
  "facilitiesForm_standardTypeOptions_office": "Kontor",
  "facilitiesForm_standardTypeOptions_shopping_mall": "Indkøbscenter",
  "facilitiesForm_standardTypeOptions_shop": "Butik",
  "facilitiesForm_selectFacilitiesForDataCollection": "2. Vælg faciliteter til dataindsamling",
  "facilitiesForm_preselectedMandatoryItems": "Følgende forudvalgte elementer er obligatoriske",
  "facilitiesForm_mandatoryFacilitiesFor": "Obligatoriske faciliteter til",
  "facilitiesForm_optionalFacilitiesFor": "Valgfri faciliteter til",
  "facilitiesForm_standard": "Standard",
  "facilitiesForm_preselectedOptionalItems": "Følgende punkter er valgfrie",
  "facilitiesForm_faq_mandatoryFacilities": "Hvad er obligatoriske faciliteter?",
  "facilitiesForm_faq_AnswerMandatoryFacilities": "Det er standardfaciliteter, som vi finder i ejendomme af din art. For at generere vores tilgængelighedsdata på en grundig måde, skal disse faciliteter vurderes. EX indgangen til bygningen",
  "facilitiesForm_faq_optionalFacilities": "Hvad er valgfri faciliteter?",
  "facilitiesForm_faq_AnswerOptionalFacilities": "Dette er en ikke-udtømmende liste over faciliteter, der måske eller måske ikke er tilgængelige på dit ejendom, men som ikke nødvendigvis er standardfaciliteter på et ejendom som dit. For eksempel en spa på et hotel eller i et indkøbscenter.",
  "unitForm_helperText_entrance_key": "Indgang",
  "unitForm_helperText_entrance_value": "dvs. hovedindgang eller sekundære indgange såsom via restaurant eller haver",
  "unitForm_helperText_lobby_key": "Lobbyen",
  "unitForm_helperText_lobby_value": "dvs. Ejendommens hovedlobby inklusive lounge eller venteområde",
  "unitForm_helperText_reception_key": "Reception/info skranke",
  "unitForm_helperText_reception_value": "dvs. hovedindtjekningsskranke, conciergeskranke, bagageopbevaringsområde eller informationsskrankeområder",
  "unitForm_helperText_facility_key": "Facilitet",
  "unitForm_helperText_facility_value": "",
  "unitForm_helperText_parking_key": "Parkering og nær omgivelser",
  "unitForm_helperText_parking_value": "dvs. hovedparkeringsområde og yderligere udendørsarealer såsom haver, indkørsler, gangbroer",
  "unitForm_helperText_commonAreas_key": "Fællesarealer",
  "unitForm_helperText_commonAreas_value": "Fælles offentlige områder på hotellet såsom Lobby Lounge, korridorer osv.",
  "unitForm_helperText_conferenceRoom_key": "Mødelokale/mødelokale",
  "unitForm_helperText_conferenceRoom_value": "",
  "unitForm_helperText_auditorium_key": "Auditorium",
  "unitForm_helperText_auditorium_value": "Teaterstil, biograf mm.",
  "unitForm_helperText_diningArea_key": "Spisestue",
  "unitForm_helperText_diningArea_value": "f.eks. hovedrestaurant, morgenmadsbuffetområde, lobbybar/bistro",
  "unitForm_helperText_toiletRoom_key": "Toiletrum (fælles, delt)",
  "unitForm_helperText_toiletRoom_value": "dvs. Fælles toilet/badeværelse tilgængeligt fra lobby, restaurant eller andre offentlige områder",
  "unitForm_helperText_gym_key": "Gym",
  "unitForm_helperText_gym_value": "",
  "unitForm_helperText_spa_key": "Spa",
  "unitForm_helperText_spa_value": "",
  "unitForm_helperText_hospitalityRoom_key": "Værelsestype",
  "unitForm_helperText_hospitalityRoom_value": "dvs. værelsestype, fx enkelt, dobbelt, tilgængeligt, familie mv",
  "unitForm_quantityLabel": "Vælg mængde",
  "unitForm_locationFaq": "Hvor er den placeret?",
  "unitForm_totalQuantity": "Samlet mængde",
  "unitForm_floorSelection": "Vælg etage",
  "unitForm_finishedCreation": "Er du færdig med at oprette enheder?",
  "unitForm_startClassifying": "Spørgeskemaundersøgelse!",
  "unitForm_unitData2": "Privat toilet",
  "unitForm_unitData3": "Privat badeværelse",
  "unitForm_unitData4": "Privat køkken",
  "unitForm_unitTypeDetails": "3. Oplysninger om enhedstype:",
  "unitForm_unitName": "Indtast enhedsnavnet her",
  "unitForm_accessibleUnit": "Denne enhed anses for tilgængelig",
  "questionUnits_addNewUnit": "Tilføj ny enhed",
  "questionUnits_savedInfo": "Dine oplysninger blev gemt",
  "questionUnits_removedInfo": "Dine oplysninger blev slettet",
  "questionUnits_resources": "Ressourcer",
  "questionUnits_uploadPictures": "Upload billeder",
  "questionUnits_explanation": "Nogle forklaringer/detaljer om dette afsnit kan findes her",
  "questionUnits_uploadLabel": "UPLOAD",
  "questionUnits_unitExtraInfo": "Enhed Ekstra info",
  "questionUnits_unitExtraInfoPlaceholder1": "Her kan du indsætte private kommentarer til denne specifikke enhed",
  "questionUnits_unitExtraInfoPlaceholder2": "(i øjeblikket har du ingen kommentarer til denne enhed)",
  "questionUnits_beforeClassification": "Du bør tilføje faciliteter, før du begynder at klassificere",
  "questionUnits_editFacilities": "Redigeringsfaciliteter",
  "questionUnits_addNew": "Klik på \"Tilføj ny\", eller vælg enhed for at begynde at klassificere",
  "questionUnits_faq1": "Info",
  "questionUnits_faq2": "Hvad er obligatoriske faciliteter?",
  "questionUnits_faq2_1": "Det er standardfaciliteter, som vi finder i ejendomme af din slags. For at kunne generere vores tilgængelighedsdata på en grundig måde, skal disse faciliteter vurderes. Eks. indgangen til bygningen",
  "questionUnits_faq3": "Hvad er valgfrie faciliteter?",
  "questionUnits_faq3_1": "Dette er en ikke-udtømmende liste over faciliteter, der måske eller måske ikke er tilgængelige i dit ejendom, men som ikke nødvendigvis er standardfaciliteter i et ejendom som dit. For eksempel en spa på et hotel eller i et indkøbscenter.",
  "FAR_SelectProperty": "Vælg anlæg",
  "FAR_DocumentPreview": "Dokumenteksempel:",
  "FAR_DownloadPDF": "Download PDF:",
  "FAR_Download": "Hent nu!",
  "CLP_SelectProperty": "Vælg anlæg",
  "CLP_SelectPropertyForChecklist": "Vælg en ejendom for at oprette tjeklisten",
  "CLP_AccessibilityChecklist": "Tilgængelighedstjekliste",
  "CLP_GeneratedOn": "Genereret den",
  "CLP_GeneratedBy": "Genereret af",
  "CLP_LoadingDoc": "Indlæser dokumenter...",
  "CLP_DownloadNow": "Hent nu!",
  "A11yUnitsPageSubTitle": "Ting at huske på",
  "A11yUnitsPageDescription": "Du kan kun tilknytte enheder, der ligner hinanden, hvis de er nøjagtigt ens. Ellers skal der oprettes en anden enhedstype.",
  "routes_NewProperty": "Ny ejendom",
  "routes_EditProperty": "Rediger egenskab",
  "routes_EditFacility": "Rediger facilitet",
  "routes_SelectFacilities": "Vælg Faciliteter",
  "routes_CreateProperty": "Opret ejendom",
  "routes_Classify": "Klassificer",
  "routes_Blank": "Blank",
  "changePassword_success": "Succes",
  "changePassword_successMessage": "Din adgangskode er blevet opdateret",
  "changePassword_returnToLogin": "Vend tilbage til login",
  "changePassword_resetPassword": "Nulstil din adgangskode",
  "changePassword_newPassword_label": "nyt kodeord",
  "changePassword_confirmNewPassword_label": "Bekræft ny adgangskode",
  "changePassword_newPasswordRequired_errorMessage": "Ny adgangskode er påkrævet",
  "changePassword_newPasswordMismatch_errorMessage": "kodeordene skal være ens",
  "changePassword_newPassword_browserTab": "Skift kodeord",
  "DocumentationPage_pageTitle": "Dokumentationsside",
  "DocumentationPage_tabtitle": "Dokumentation",
  "DownloadsPage_pageTitle": "Downloads side",
  "LanguagesDropdown_English": "Engelsk",
  "LanguagesDropdown_French": "Fransk",
  "LanguagesDropdown_German": "Tysk",
  "LanguagesDropdown_Dutch": "Hollandsk",
  "LocationAutocomplete_searchPlaceholder": "Søg efter steder...",
  "LocationAutocomplete_validAddress": "Angiv venligst husnummer og vej",
  "LocationAutocomplete_addressEmpty": "Adressen må ikke være tom",
  "page404_PageNotFound": "Siden blev ikke fundet.",
  "page404_PageNotFound_explanation": "Den side, du leder efter, er muligvis blevet fjernet.",
  "page404_PageNotFound_returnHome_button": "Tilbage til hjemmesiden",
  "page500_InternalError": "Intern serverfejl.",
  "page500_InternalError_explanation": "Servern stødte på noget udestående som intet tillät den at slutföra anmodning.",
  "propertyListPage_NotClassified": "Ikke klassificeret",
  "propertyListIconName_allergy_food_class": "Allergi mad klasse",
  "propertyListIconName_allergy_room_class": "Allergirumsklasse",
  "propertyListIconName_mobility_class": "Mobilitetsklasse",
  "propertyListIconName_hearing_class": "Høreklasse",
  "propertyListIconName_cognitive_class": "Kognitiv klasse",
  "propertyListIconName_visual_class": "Visuel klasse",
  "propertyForm_AllStepsCompleted": "Alle trin gennemført",
  "propertyForm_propertyReady": "Din ejendom er nu klar!",
  "propertyForm_propertyReady_description": "Du har afsluttet dit ejendomsinformationstrin. Du kan redigere disse oplysninger ved at klikke på linket Egenskabsliste øverst til venstre.",
  "propertyForm_startClassifying": "START AT KLASSIFICERE",
  "propertyForm_propertyStepper_step1": "Tilføj ejendomsoplysninger",
  "propertyForm_propertyStepper_step2": "Vælg Faciliteter",
  "propertyForm_propertyStepper_step3": "Tilføj enhedsdetaljer",
  "settingsForms_CompanyInformation_SelectOptions_Service": "Service",
  "settingsForms_CompanyInformation_SelectOptions_Merchandising": "Merchandising",
  "settingsForms_CompanyInformation_SelectOptions_Manufacturing": "Fremstilling",
  "settingsForms_CompanyInformation_SelectOptions_Other": "Andet",
  "settingsForms_ImageCantBeChanged": "Dette billede kan ikke ændres",
  "settingsForms_RegNumber_label": "Reg nummer",
  "settingsForms_InvoiceStatus_label": "Fakturastatus",
  "settingsForms_CompanyName_label": "firmanavn",
  "settingsForms_CompanyType_label": "Firmatype",
  "settingsForms_CompanySize_label": "Firma størrelse",
  "settingsForms_CompanyAddress_label": "Virksomhedens adresse",
  "settingsForms_ContractDate_label": "Dato for kontraktunderskrivelse",
  "settingsForms_SubscriptionPeriod_label": "Abonnementsperiode",
  "settingsForms_Employees_label": "Medarbejdere",
  "settingsForms_UserInformation_positionOptions_owner": "Ejer",
  "settingsForms_UserInformation_positionOptions_executive": "Executive",
  "settingsForms_UserInformation_positionOptions_manager": "Manager",
  "settingsForms_UserInformation_positionOptions_operations_and_production": "Drift og produktion",
  "settingsForms_UserInformation_positionOptions_other": "Andet",
  "settingsForms_UserInformation_departmentOptions_it": "DET",
  "settingsForms_UserInformation_departmentOptions_marketing": "Markedsføring",
  "settingsForms_UserInformation_departmentOptions_finance": "Finansiere",
  "settingsForms_UserInformation_departmentOptions_human_resources": "Menneskelige ressourcer",
  "settingsForms_UserInformation_departmentOptions_sales": "Salg",
  "settingsForms_UserInformation_departmentOptions_operations": "Operationer",
  "settingsForms_UserInformation_departmentOptions_other": "Andet",
  "settingsForms_UserInformation_title": "Brugeroplysninger",
  "settingsForms_UserInformation_UploadPicture": "Upload billede",
  "settingsForms_UserInformation_formatRestriction": "Brug et billede på mindst 128px x 128px i .jpg-format",
  "settingsForms_UserInformation_surname": "Efternavn",
  "settingsForms_UserInformation_position": "Position",
  "settingsForms_UserInformation_department": "Afdeling",
  "settingsPage_pageTitle": "Indstillinger side",
  "settingsPage_breadcrumbs_dashboard": "Dashboard",
  "settingsPage_breadcrumbs_settings": "Indstillinger",
  "signinForm_explanation": "Log ind på din konto for at fortsætte",
  "signinForm_validEmail_error": "Skal være en gyldig e-mail",
  "signinForm_emailRequired": "E-mail er påkrævet",
  "signinForm_generalError": "Noget gik galt",
  "signinForm_passwordRequired": "adgangskode er påkrævet",
  "signinForm_emailLabel_textfield": "Email adresse",
  "signinForm_passwordLabel_textfield": "Adgangskode",
  "signinForm_remberMeCheckbox_textfield": "Husk mig",
  "signinForm_signIn_button": "Log ind",
  "signinForm_forgotPassword_button": "Glemt kodeord",
  "signupForm_signUp_button": "Tilmelde",
  "signupForm_signUp_title": "Kom igang",
  "signupForm_signUp_subTitle": "Begynd at skabe den bedst mulige brugeroplevelse for dine kunder",
  "signupForm_signUp_nameRequired": "Navn er påkrævet",
  "signupForm_signUp_minCharacters_errorMessage": "Skal være på mindst 12 tegn",
  "signupForm_signUp_required_errorMessage": "Påkrævet",
  "signupForm_signUp_nameLabel": "Navn",
  "signupForm_signUp_companyLabel": "Selskab",
  "signupForm_signUp_emailAddressLabel": "Email adresse",
  "signupForm_signUp_passwordLabel": "Adgangskode",
  "signupForm_signUp_confirmPasswordLabel": "Bekræft kodeord",
  "statsPage_pageTitle": "Statistik side",
  "statsPage_cardContent": "Denne side vil være tilgængelig i fremtidige versioner af Accessibility Management System.",
  "resetPassword_inbox": "Se i din indbakke",
  "resetPassword_explanation_1": "Vi har sendt en mail til",
  "resetPassword_explanation_2": "med instruktioner til gendannelse af adgangskode",
  "resetPassword_title": "Nulstille kodeord",
  "resetPassword_subTitle": "Indtast din e-mail for at nulstille din adgangskode",
  "unitForm_title": "Sammensatte enheder",
  "unitForm_floorTitle": "Etage",
  "unitImagesDialog_labelMANDATORY": "OBLIGATORISK",
  "unitImagesDialog_labelOPTIONAL": "VALGFRI",
  "unitImagesDialog_labelPICTURES": "BILLEDER",
  "unitImagesDialog_dropzone": "Slip billeder her, eller vælg en fil",
  "userDropdown_profile": "Profil",
  "userDropdown_signout": "Log ud",
  "questionUnits_uploadPictures_uploadError": "Der opstod en fejl under upload af billeder",
  "questionUnits_uploadSuccess": "Dine data er blevet indsendt med succes",
  "questionUnits_unitExtraInfoLabel": "Ekstra info",
  "questionUnits_unitExtraInfoDelete_button": "Slet",
  "questionUnits_unitExtraInfoSave_button": "Gemme",
  "QuestionnaireCompletionCard_title": "Udfyldelse af standarder",
  "QuestionnaireCompletionCard_disableMessage": "Du har ikke nogen klassifikation endnu.",
  "QuestionnaireCompletionCard_ParkingCard": "Parkering",
  "QuestionnaireCompletionCard_EntranceCard": "Indgang",
  "QuestionnaireCompletionCard_ToiletCard": "Toilet",
  "QuestionnaireCompletionCard_RoomsCard": "Værelser",
  "QuestionnaireCompletionCard_LiftAndElevatorsCard": "Elevator og elevatorer",
  "QuestionnaireCompletionCard_LobbyAndReceptionCard": "Lobby og reception",
  "FAR_Report": "Tilgængelighedsrapport",
  "FAR_TableUnitName": "Enhedens navn",
  "FAR_TableDescription": "Beskrivelse",
  "CLP_PleaseSelectProperty": "Vælg venligst ejendom",
  "CLP_BrowserTabTitle": "Fuld tilgængelighedsrapport",
  "CLP_UnitMandatoryLabel": "Obligatorisk",
  "CLP_UnitDoneLabel": "FÆRDIG",
  "propertyPage_Controllers_SearchDoc": "Søg i dokumentation",
  "generalWords_Yes": "Ja",
  "generalWords_No": "Ingen",
  "generalWords_Next": "Næste",
  "generalWords_Close": "Tæt",
  "generalWords_Reset": "Nulstil",
  "generalWords_Back": "Tilbage",
  "generalWords_Finish": "Afslut",
  "generalWords_NextStep": "Næste skridt",
  "generalWords_Edit": "Redigere",
  "generalWords_Download": "Hent",
  "generalWords_Delete": "Slet",
  "generalWords_SaveChanges": "Gem ændringer",
  "generalWords_Selected": "valgte",
  "generalWords_Required": "Påkrævet",
  "customerSupportPage_title": "Kundesupportside",
  "customerSupportPage_emailLabel": "Kontakt kundesupport på:",
  "unitForm_helperText_entrance": "dvs. hovedindgang eller sekundære indgange såsom via restaurant eller haver.",
  "unitForm_helperText_lobby": "dvs. ejendom hovedlobby inklusive lounge eller venteområde.",
  "unitForm_helperText_reception": "dvs. hovedindtjekningsskranke, conciergeskranke, bagageopbevaringsområde eller informationsskrankeområder.",
  "unitForm_helperText_facility": "dvs. navnet på anlægget eller ejendommen.",
  "unitForm_helperText_parking": "dvs. hovedparkeringsområde og yderligere udendørsarealer såsom haver, indkørsler, gangbroer.",
  "unitForm_helperText_conferenceRoom": "Et konferencelokale er et stort lokale, hvor et antal personer kan holde konference.",
  "unitForm_helperText_auditorium": "Teaterstil, biograf mm.",
  "unitForm_helperText_diningArea": "f.eks. hovedrestaurant, morgenmadsbuffetområde, lobbybar/bistro.",
  "unitForm_helperText_toiletRoom": "dvs. Fælles toilet/badeværelse tilgængeligt fra lobby, restaurant eller andre offentlige områder.",
  "unitForm_helperText_gym": "Fysiske øvelser og aktiviteter udført inde, ofte ved hjælp af udstyr.",
  "unitForm_helperText_spa": "Sted, hvor man kan slappe af gennem en sauna, pool og jacuzzi.",
  "unitForm_helperText_hospitalityRoom": "dvs. værelsestype, fx enkelt, dobbelt, tilgængeligt, familie mv.",
  "unitForm_helperText_shopping_aisle": "dvs. gang mellem hylderne.",
  "unitForm_helperText_counter": "En plan overflade (såsom et bord, en hylde eller et vitrineskab), som transaktioner udføres over.",
  "unitForm_helperText_checkout_pay": "f.eks Kasse, Selvbetjening, Selvscanning.",
  "unitForm_helperText_fitting_room": "Et rum i en butik, hvor kunderne kan tage et stykke tøj på for at se, om det passer, før de køber det.",
  "unitForm_helperText_manned_kiosk": "En kasse- eller indløsningsterminal, som giver mulighed for kontante og kontantløse transaktioner med en kasserer.",
  "unitForm_helperText_floor": "dvs. tilgængeligheden på forskellige niveauer såsom stueetage, elevator på 1 sal, grøn elevator ved indgang 2.",
  "unitForm_helperText_playground": "Et område, der bruges af børn til at lege i. De har normalt udstyr såsom rutsjebaner, gynger og vipper, som børn kan lege på.",
  "unitForm_helperText_garden": "Et rum, som regel udendørs, afsat til dyrkning, fremvisning og nydelse af planter og andre former for natur.",
  "unitForm_helperText_bathroom_common": "Et værelse med badekar eller bruser og normalt en håndvask og toilet.",
  "unitForm_helperText_bathroom__private": "Et privat værelse med badekar eller bruser og normalt en håndvask og toilet.",
  "unitForm_helperText_quiet_room": "Et stillerum eller stillerum er et rum bygget med hensyn til stilhed ved at afskærme støj fra eller mod omgivelserne.",
  "unitForm_helperText_kitchen_common": "Et offentligt lokale, hvor man kan tilberede og lave mad.",
  "unitForm_helperText_toilet_room__private": "dvs. privat toilet tilgængeligt fra lobby, restaurant eller andre offentlige områder.",
  "unitForm_helperText_kitchen__private": "Et privat rum, hvor man kan tilberede og lave mad.",
  "unitForm_helperText_conferenceRoom_": "",
  "routes_Services": "Tjenester",
  "routes_Help": "Hjælp",
  "routes_Clp": "Tjekliste",
  "routes_Far": "Tilgængelighedsrapport",
  "FAR_WhatIsItTitle": "Hvad er en tilgængelighedsrapport?",
  "FAR_WhatIsItDescription": "Tilgængelighedsrapport er en rapport, som vi genererer til dig afhængigt af, hvor tilgængelig din ejendom er. Nedenfor kan du vælge en ejendom og downloade dens PDF-rapport.",
  "FAR_MoreInfo": "For mere information om tilgængelighedsrapport venligst",
  "FAR_SelectPropertyForChecklist": "Vælg en ejendom for at oprette rapporten",
  "CLP_noChecklistFound": "Vi kunne ikke finde en liste for denne ejendom",
  "CLP_WhatIsItTitle": "Hvad er en tjekliste?",
  "CLP_WhatIsItDescription": "Tjeklisten er en liste baseret på tilgængelighedssystemets opgørelsesoplysninger. Den viser forbedringsområderne, baseret på dine input i systemet. Et eksempel på dokumentet er tilgængeligt og kan downloades eller udskrives.",
  "CLP_MoreInfo": "For mere information om tjekliste venligst",
  "CLP_FAR_ConsultTheDocumentation": "konsultere dokumentationen",
  "LanguagesDropdown_Swedish": "Svensk",
  "LanguagesDropdown_Danish": "Dansk",
  "gettingStartedCard_step1_link": "Læs",
  "gettingStartedCard_step2_link": "Hent",
  "gettingStartedCard_step3_link": "Tjek",
  "contactForm_category": "Kategori",
  "contactForm_title": "Kontakt os",
  "contactForm_chooseImg": "Vælg billede",
  "contactForm_submitBtn": "Send anmodning",
  "contactForm_attachBtnLabel": "Vedhæft venligst et skærmbillede.",
  "contactForm_messageLabel": "Beskriv venligst hvad du efterspørger her.",
  "contactForm_messageEmptyError": "Tilføj venligst en besked",
  "contactForm_categoryOptions_ServiceInquiry": "Serviceforespørgsel",
  "contactForm_categoryOptions_TechnicalIssues": "Tekniske problemer",
  "contactForm_categoryOptions_OtherInquires": "Andre henvendelser",
  "contactForm_subtitle1": "Hvis du ikke kan finde det svar, du leder efter, er vi her for at give en hånd med.",
  "contactForm_subtitle2": "Skriv venligst til os! Vi vender tilbage til dig hurtigst muligt.",
  "FAR_noDataAvalible_1": "Tilgængelighedsrapporten kan endnu ikke genereres for denne ejendom. Udfyld venligst",
  "FAR_noDataAvalible_2": "til",
  "FAR_noDataAvalible_3": "først.",
  "CLP_Updating": "Opdaterer...",
  "CLP_AreYouSure": "Er du sikker?",
  "CLP_UpdateMessage": "Hvis du gør dette, forsvinder varen fra tjeklisten, og standarden vil automatisk blive opdateret, hvilket afspejler ændringen.",
  "CLP_Cancel": "AFBESTILLE",
  "CLP_YesUpdate": "JA, OPDATERING",
  "CLP_WhatIsAChecklist": "Hvad er en tjekliste?",
  "CLP_Name": "Navn",
  "CLP_pdfDisclaimer": "Bemærk: Når du har foretaget forbedringerne, så glem ikke at opdatere dine tilgængelighedsdata i standardafsnittet.",
  "CLP_FAR_noAccessibilityDataAvailable1": "Vi har ingen tilgængelighedsdata tilgængelige. ",
  "CLP_noChecklist1": "Tjeklisten kan endnu ikke genereres for denne ejendom. Besvar spørgsmålene inde i ",
  "CLP_noChecklist2": "standard afsnit ",
  "CLP_noChecklist3": "til",
  "CLP_noChecklist4": "først.",
  "CLP_FAR_noAccessibilityDataAvailable2": "Opret en ejendom",
  "CLP_FAR_noAccessibilityDataAvailable3": " og svar på spørgsmålene inde i standard afsnit først.",
  "statsPage_subscriptionExpiring": "Abonnementet udløber om",
  "statsPage_days": "dage",
  "statsPage_contactCustomerSupport": "Kontakt kundesupport",
  "statsPage_companyInformation": "Virksomhedsoplysninger",
  "statsPage_numberOfPhotosUploaded": "Antal uploadede billeder",
  "statsPage_photos": "fotos",
  "statsPage_totalAmountProperties": "Samlet antal ejendomme",
  "statsPage_amountCompleted": "Nummer afsluttet",
  "statsPage_actionsPerVisitor": "Handlinger pr. besøgende på Widgetten",
  "statsPage_yourItems": "Dine genstande",
  "statsPage_name": "Navn",
  "statsPage_sku": "SKU",
  "statsPage_quantity": "Antal",
  "statsPage_numberOfUnits": "Antal enheder",
  "statsPage_accessible": "Tilgængelig",
  "statsPage_notAccessible": "Ikke tilgængelig",
  "statsPage_unit": "Enhed",
  "statsPage_amount": "Antal",
  "statsPage_incomplete": "Ufuldstændig",
  "statsPage_completed": "Færdiggjort",
  "statsPage_notCompleted": "Ikke afsluttet",
  "statsPage_mobility": "Mobilitet",
  "statsPage_cognitive": "Kognitiv",
  "statsPage_hearing": "Høring",
  "statsPage_visual": "Visuel",
  "statsPage_allergy": "Allergi",
  "statsPage_class": "Klasse",
  "statsPage_totalAccessibilityDatapoints": "Samlede tilgængelighedsdatapunkter",
  "statsPage_visitorsThatOpened": "Besøgende der åbnede Widgetten",
  "statsPage_visitorsInteraction": "Samlede handlinger på Widgetten",
  "statsPage_action": "Handling",
  "statsPage_clicks": "Kliker",
  "statsPage_noDataAvailable_topText": "Der er ingen tilgængelige data",
  "statsPage_noDataAvailable_bottomText": "I øjeblikket",
  "statsPage_company_address": "Adresse",
  "statsPage_company_city": "By",
  "statsPage_company_country": "Land",
  "statsPage_company_name": "Navn",
  "statsPage_company_type": "Type",
  "statsPage_company_registration_number": "Registreringsnummer",
  "statsPage_company_logo": "Logo",
  "statsPage_company_employees": "Medarbejdere",
  "statsPage_company_empty_fields": "Tomme felter",
  "settingsPage_alertMsgImageUpload": "Klik på Gem for at opdatere dit profilbillede",
  "settingsPage_alertMsgCompanyInformation_1": "Kontakt",
  "settingsPage_alertMsgCompanyInformation_2": "kundesupport",
  "settingsPage_alertMsgCompanyInformation_3": "hvis du har brug for at foretage ændringer i virksomhedsoplysninger.",
  "documentationPage_downloadDocument": "Download dokument",
  "documentationPage_loadingDocument": "Indlæser dokument",
  "CLP_Status": "Status",
  "CLP_lastUpdate": "Sidste ændring",
  "CLP_completed": "afsluttet",
  "CLP_incomplete": "ufuldstændig",
  "LanguagesDropdown_Languages": "Sprog",
  "login_welcome_message": "Velkommen til Accessibility Management Systemet 👋",
  "CLP_Checklist_is_generated_based": "Tjeklisten genereres baseret på de tilgængelighedsdata, som vi indsamler fra din ejendom. Den viser forbedringsområderne, og når du har markeret punktet, opdateres svaret automatisk i systemet, og dine tilgængelighedsdata vil blive ændret. Dokumentet kan downloades til ekstern brug. For mere information",
  "CLP_Go_to_checklist": "Gå til tjeklisten",
  "CLP_Updated_date": "Opdateret dato",
  "CLP_The_purpose_of_Handiscover_1": "Formålet med Handiscovers inventar og tjekliste er at guide dig, når du forbedrer din tilgængelighed. Den vedhæftede liste består af flere punkter. Ud fra perspektivet om, at noget skal være tilgængelighedstilpasset, er der punkter, som er obligatoriske. Derudover identificerer vi punkter som vi anbefaler, om der skal bygges nyt eller renoveres.",
  "CLP_List_points": "Liste punkter",
  "CLP_Priority": "Prioritet",
  "CLP_User": "Bruger",
  "CLP_Mandatory": "Obligatorisk",
  "CLP_Need_help": "Brug for hjælp? Kontakt vores team",
  "CLP_Handiscovers_suggestions": "Handiscovers forslag",
  "propertyForm_nextStep_tooltip": "Udfyld først alle obligatoriske felter",
  "statsPage_See_photos": "Se billeder",
  "statsPage_Your_subscription": "Dit abonnement",
  "statsPage_Filter_data_from": "Filtrer data fra",
  "statsPage_Filter_data_to": "Filtrer data til",
  "statsPage_to": "til",
  "statsPage_Reload": "Genindlæs",
  "statsPage_Business_Metrics": "Forretningsmålinger",
  "statsPage_Service_Metrics": "Servicemålinger",
  "statsPage_Statistics_page": "Statistik side",
  "imagesPage_Pictures_List": "Billedliste",
  "imagesPage_Search_by_name": "Søg på navn",
  "imagesPage_No_pictures_available": "Ingen tilgængelige billeder",
  "imagesPage_Name": "Navn",
  "imagesPage_Display_in_widget": "Vis i widget",
  "imagesPage_Type": "Type",
  "imagesPage_Update_date": "Opdateringsdato",
  "imagesPage_Mandatory": "Obligatorisk",
  "imagesPage_Are_your_sure": "Er du sikker?",
  "imagesPage_Delete": "Slet",
  "imagesPage_Yes": "Ja",
  "imagesPage_Cancel": "Afbestille",
  "imagesPage_Open_image": "Åbn billede",
  "imagesPage_Edit": "Redigere",
  "imagesPage_Delete_image": "Slet billede",
  "CLP_The_purpose_of_Handiscover_2": "Vi har også inkluderet punkter, der er \"lette\" at rette, men sandsynligvis vigtige fra et tilgængelighedsperspektiv.",
  "a11yUnits_The_title_has_been_translated": "Titlen er blevet oversat",
  "statsPage_Statistics": "Statistikker",
  "customerSupportPage_thankYou": "Tak skal du have!",
  "customerSupportPage_requestSuccessfully": "Din anmodning er blevet sendt. Vores kundesupport vil tage sig af din forespørgsel og vende tilbage til dig så hurtigt som muligt.",
  "customerSupportPage_warning": "Advarsel",
  "customerSupportPage_error": "Fejl",
  "propertyListPage_showAll": "Vis alt",
  "propertyListPage_completed": "Afsluttet",
  "propertyListPage_incomplete": "Ufuldstændig",
  "dashboard": "Dashboard",
  "widget": "Widget",
  "property_type": "Ejendomstype",
  "category": "Kategori",
  "edit_widget": "Rediger widget",
  "created": "Oprettet",
  "published": "Udgivet",
  "unpublished": "Upubliceret",
  "widget_info": "Tilgængelighedswidgetten viser detaljerede tilgængelighedsdata, der tidligere er logget i Accessibility Management System. Denne widget gør det muligt at skabe bedre betingelser for, at besøgende kan planlægge deres ophold på forhånd ved at se tilgængeligheden. Tilgængelighedswidgetten er interaktiv, da alle data, der er opdateret i systemet, afspilles i widgetten.",
  "view_live_widget": "Se live widget",
  "no_widget_data_message": "Vi har ikke widgetdata. Kontakt venligst vores kundeserviceteam.",
  "image_list": "Billedliste",
  "language_setting": "Sprogindstilling",
  "history": "Historie",
  "select_accessibility_unit": "Vælg tilgængelighedsenhed",
  "add_new_image": "Tilføj nyt billede",
  "order": "Rækkefølge",
  "image": "Billede",
  "description": "Beskrivelse",
  "accessibility_unit": "Tilgængelighedsenhed",
  "accessibility": "Tilgængelighed",
  "displayed_in_widget": "Vises i widget",
  "current_image": "Nuværende billede",
  "upload_new_picture": "Upload nyt billede",
  "image_description": "Billedbeskrivelse",
  "image_order": "Billedrækkefølge",
  "back_to_list": "Tilbage til listen",
  "no_picture": "Intet billede",
  "please_write_the_text_in": "Skriv venligst teksten ind",
  "yes_delete": "JA, SLET",
  "delete_warning_text": "Hvis du gør dette, forsvinder elementet fra widget'en, og standarden vil automatisk blive opdateret, hvilket afspejler ændringen.",
  "select_language_the_widget_provide": "Vælg det sprog, som widgetten giver",
  "changed_by": "Ændret af",
  "activity": "Aktivitet",
  "showing": "Viser",
  "of": "af",
  "items": "elementet",
  "questionnaire": "Spørgeskema",
  "we_are_showing_followings": "Vi viser følgende i din Widget",
  "we_are_recommended_to_state": "Vi anbefales at angive nogle praktiske oplysninger i widgetten for besøgende på din ejendom. Hvis du gerne vil redigere den, bedes du kontakte vores kundeservice",
  "select_what_you_want_to_show": "Vælg, hvad du vil vise i widget",
  "practical_information": "Praktisk information",
  "you_can_add_maximum": "Du kan maksimalt tilføje 3 sætninger",
  "for_the_best_experiences_in_widget": "For de bedste oplevelser i Widget hjælper vi dig, hvis du ønsker at tilføje flere oplysninger",
  "if_you_do_this_the_item_will_disappear": "Hvis du gør dette, forsvinder elementet fra widget'en",
  "you_can_write_free_texts": "Du kan skrive fritekster for at tilføje til den generelle information, hvis det er nødvendigt. Max 40 tegn",
  "write_a_new_information": "Skriv en ny information",
  "you_can_drag_and_drop_the_block": "Du kan trække og slippe blokken for at ændre ordrerne. Vælg venligst afkrydsningsfeltet for at præsentere i widgetten.",
  "you_can_freely_change_the_images_ordering": "Du kan frit ændre billedrækkefølgen ved at trække og slippe.",
  "preview": "Forhåndsvisning",
  "add_point_on_map": "Tilføj punkt på kortet",
  "LanguagesDropdown_Spanish": "spansk",
  "LanguagesDropdown_Norwegian": "Norsk",
  "LanguagesDropdown_Portuguese": "portugisisk",
  "LanguagesDropdown_Ukrainian": "ukrainsk",
  "main_unit_image": "Hovedenhedsbillede(r)",
  "item_pictures": "Varebilleder",
  "please_choose_a_main_unit_image": "Vælg venligst et hovedenhedsbillede",
  "please_choose_a_item_picture": "Vælg venligst et varebillede",
  "button_settings_updated": "Knapindstillingerne er blevet opdateret",
  "button_settings_created": "Knapindstillingerne er blevet oprettet med succes",
  "button_settings": "Knapindstillinger",
  "webmaster_instruction": "Undervisning af webmastere",
  "contract_has_expired": "Din kontrakt er udløbet. Widgeten er blevet suspenderet. Kontakt support",
  "webmaster_instructions_are_not_available": "Webmaster-instruktioner er ikke tilgængelige i øjeblikket. Kontakt support",
  "create_api_key": "Opret API-nøgle til denne virksomhed",
  "standard_instruction": "Standardinstruktion",
  "google_tag_manager_instruction": "Instruktion i Google Tag Manager"
}